import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useLocation } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import stl from './Payment.module.css';
import CheckoutForm from "../../organisms/CheckoutForm";
import { Preloader } from "../../atoms/Preloader";
import { logEvent } from "../../amplitude";
import getGuestId from "../../storage/getGuestId";
import axios from 'axios';

const Payment = () => {
    const location = useLocation();
    const guestId = getGuestId();
    const { feedback } = location.state || {};
    const storedBody = localStorage.getItem('body');
    const feedbackData = feedback || JSON.parse(storedBody);
    const [clientSecret, setClientSecret] = useState('');
    const [error, setError] = useState(null);

    // CHANGED: всегда ключ платформы, без stripeAccount
    const [stripePromise] = useState(() =>
        loadStripe(
            feedbackData?.mode === 'prod'
                ? 'pk_live_51RTWmSKu2Tj0z07KsFODir5NHSB0kMd2GTgZmrLNcMHch4G2Bh5UWRTCVjEIeh2wKYj5qrczFUfItLCuFurfFVHR00ZXkDYiA7'
                : 'pk_test_51RTWmdQQC2PZ0HvBsnrQnYzOQPTCqnopFbE9ZPSkTdTsE0GaldauYe8r9DBuCDFiM1ruZYQ0o09S2dYt5oClVUt500ncffSJeX'
        )
    );

    useEffect(() => {
        logEvent("Page view", {
            Title: 'Payment',
            Path: location.pathname,
            URL: window.location.href,
            'Guest ID': guestId,
        });
    }, []);

    useEffect(() => {
        if (!feedbackData) {
            console.error('No product data provided.');
            return;
        }

        // NEW: целые суммы в центах
        const amountCents = Math.round(Number(feedbackData.amount) * 100);
        const feeCents = Math.round(
            Number(
                feedbackData?.commissionChecked
                    ? feedbackData?.fee
                    : feedbackData?.stripeFee || 0
            ) * 100
        );

        // CHANGED: отправляем application_fee_amount и currency
        const requestBody = {
            amount: amountCents,                              // int cents
            currency: feedbackData?.currency || 'usd',       // NEW
            service_id: feedbackData?.serviceId,
            description: feedbackData?.name,
            connected_account_id: feedbackData?.connected_account_id,
            mode: feedbackData?.mode,
            application_fee_amount: feeCents,                 // NEW вместо fee
        };
        console.log(requestBody, 'requestBody')
        axios
            .post(
                'https://naoxvicvbnefghrluslj.supabase.co/functions/v1/create-intent',
                requestBody
            )
            .then((response) => {
                const data = response.data;
                if (data?.client_secret) {
                    setClientSecret(data.client_secret);
                } else {
                    console.error('No client_secret received from backend:', data);
                    setError('Failed to load payment form.');
                }
            })
            .catch((e) => {
                console.error('Error fetching client_secret:', e);
                setError('Failed to load payment form. Please try again later.');
            });
    }, [feedbackData]);

    const appearance = {
        theme: 'flat',
        rules: { '.Label': { fontSize: '0px' } },
    };
    const options = { clientSecret, appearance };

    if (!feedbackData) return <div>No product information provided</div>;

    return (
        <div className={stl.container}>
            <div className={stl.containerInner}>
                {error && <p>{error}</p>}
                {clientSecret && (
                    <Elements stripe={stripePromise} options={options}>
                        <CheckoutForm clientSecret={clientSecret} product={feedbackData} />
                    </Elements>
                )}
                {!clientSecret && !error && <Preloader />}
            </div>
        </div>
    );
};

export default Payment;
